import { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';
import { getAttachmentsPickerClickHandler } from '@sdk/attachments/helpers/getAttachmentsPickerClickHandler';
import useToast from '@sdk/common/toast/useToast';
import useAttachments from '@sdk/attachments/hooks/useAttachments';

import { TaskTemplateFormValues } from '@web/shiftTasks/ComposeTask/types/TaskTemplateFormValues';
import { Attachment } from '@web/shiftTasks/types/Attachment';

type Props = {
  onChange: (attachments: Attachment[]) => void;
};

export const useAttachmentsField = ({ onChange }: Props) => {
  const { showErrorToast } = useToast();
  const {
    getValues,
    formState: { errors },
  } = useFormContext<TaskTemplateFormValues>();
  const formAttachments = getValues('attachments');
  const attachmentsState = useAttachments(formAttachments, showErrorToast);
  const { attachments, addAttachmentsFromFilelist } = attachmentsState;
  const attachmentsCount = attachments.editable.length;

  useEffect(() => {
    onChange(attachments.toSave);
  }, [onChange, attachments.toSave]);

  const onOpen = (e: React.SyntheticEvent) => {
    e.preventDefault(); // this prevents parent modal from closing
  };
  const { onClick } = getAttachmentsPickerClickHandler(addAttachmentsFromFilelist, onOpen);

  return { attachmentsState, attachmentsCount, errors, onClick };
};
